/* CRO2610 International: menu drawer, country picker, product choices, add to cart, cart quantities.
   Loaded only for the international market (layout/theme.liquid). No other script depends on it. */
(function () {
  'use strict';
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function post(path, body) {
    return fetch(root + path, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      // other scripts on the page may read the answer first; go by the status then
      if (r.bodyUsed) return { ok: r.ok, data: {} };
      return r.json().then(function (d) { return { ok: r.ok, data: d }; }, function () { return { ok: r.ok, data: {} }; });
    });
  }

  function setCount(n) { $$('[data-twi-count]').forEach(function (el) { el.textContent = n; el.setAttribute('data-n', n); }); }

  /* Menu drawer */
  var drawer = $('[data-twi-drawer]');
  function openDrawer(on) {
    if (!drawer) return;
    if (on) { drawer.setAttribute('open', ''); document.documentElement.style.overflow = 'hidden'; var c = $('[data-twi-close]', drawer); if (c) c.focus(); }
    else { drawer.removeAttribute('open'); document.documentElement.style.overflow = ''; var b = $('[data-twi-open]'); if (b) b.focus(); }
  }
  $$('[data-twi-open]').forEach(function (b) { b.addEventListener('click', function () { openDrawer(true); }); });
  $$('[data-twi-close]').forEach(function (b) { b.addEventListener('click', function () { openDrawer(false); }); });
  if (drawer) drawer.addEventListener('keydown', function (e) { if (e.key === 'Escape') openDrawer(false); });

  /* Country pickers send their form at once */
  $$('[data-twi-autosubmit]').forEach(function (s) { s.addEventListener('change', function () { if (s.form) s.form.submit(); }); });

  /* Product page */
  var form = $('[data-twi-product]');
  if (form) {
    var data = {};
    try { data = JSON.parse($('[data-twi-variants]', form).textContent); } catch (e) { data = { variants: [] }; }
    var chosen = (data.current || '').split('|~|');
    var idInput = $('[name="id"]', form), priceEl = $('[data-twi-price]', form), compareEl = $('[data-twi-compare]', form);
    var btn = $('[data-twi-add]', form), mainImg = $('[data-twi-main]'), added = $('[data-twi-added]', form), err = $('[data-twi-err]', form);
    var addLabel = btn ? btn.getAttribute('data-label') : '';

    function findVariant() {
      for (var i = 0; i < data.variants.length; i++) {
        var v = data.variants[i], ok = true;
        for (var j = 0; j < chosen.length; j++) { if (v.options[j] !== chosen[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    function render() {
      var v = findVariant();
      $$('[data-twi-pill]', form).forEach(function (p) {
        var pos = +p.getAttribute('data-pos'), val = p.getAttribute('data-value');
        p.setAttribute('aria-pressed', chosen[pos] === val ? 'true' : 'false');
        // a value is out when no available variant has it together with the other chosen values
        var test = chosen.slice(); test[pos] = val;
        var any = data.variants.some(function (x) { return x.available && x.options.every(function (o, k) { return o === test[k]; }); });
        p.setAttribute('data-out', any ? 'false' : 'true');
      });
      $$('[data-twi-chosen]', form).forEach(function (el) { el.textContent = chosen[+el.getAttribute('data-pos')] || ''; });
      if (!v) { btn.disabled = true; btn.textContent = btn.getAttribute('data-none'); return; }
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = v.price;
      if (compareEl) { compareEl.textContent = v.compare || ''; compareEl.hidden = !v.compare; }
      btn.disabled = !v.available;
      btn.textContent = v.available ? addLabel : btn.getAttribute('data-soldout');
      if (v.image && mainImg) mainImg.src = v.image;
      if (window.history && history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); }
    }
    $$('[data-twi-pill]', form).forEach(function (p) {
      p.addEventListener('click', function () { chosen[+p.getAttribute('data-pos')] = p.getAttribute('data-value'); if (added) added.setAttribute('data-show', 'false'); render(); });
    });
    var qty = $('[name="quantity"]', form);
    $$('[data-twi-step]', form).forEach(function (b) {
      b.addEventListener('click', function () { var n = Math.max(1, (parseInt(qty.value, 10) || 1) + (+b.getAttribute('data-twi-step'))); qty.value = n; });
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (btn.disabled) return;
      btn.disabled = true; if (err) err.textContent = '';
      post('cart/add.js', { items: [{ id: +idInput.value, quantity: Math.max(1, parseInt(qty.value, 10) || 1) }] }).then(function (res) {
        btn.disabled = false;
        if (!res.ok) { if (err) err.textContent = (res.data && (res.data.description || res.data.message)) || btn.getAttribute('data-fail'); return; }
        if (added) { added.setAttribute('data-show', 'true'); added.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); }
        return fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); });
      }).catch(function () { btn.disabled = false; if (err) err.textContent = btn.getAttribute('data-fail'); });
    });
    $$('[data-twi-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        if (mainImg) mainImg.src = t.getAttribute('data-src');
        $$('[data-twi-thumb]').forEach(function (x) { x.setAttribute('aria-current', x === t ? 'true' : 'false'); });
      });
    });
    render();
  }

  /* Cart page */
  $$('[data-twi-line]').forEach(function (line) {
    var key = line.getAttribute('data-twi-line'), q = +line.getAttribute('data-qty');
    function change(n) {
      line.style.opacity = '.5';
      post('cart/change.js', { id: key, quantity: n }).then(function () { location.reload(); }, function () { location.reload(); });
    }
    $$('[data-twi-cstep]', line).forEach(function (b) { b.addEventListener('click', function () { change(Math.max(0, q + (+b.getAttribute('data-twi-cstep')))); }); });
    var rm = $('[data-twi-remove]', line);
    if (rm) rm.addEventListener('click', function () { change(0); });
  });
})();
